/**
 * 地址工具函数
 */

/**
 * 组合地址信息为完整地址字符串
 * @param addressLine1 地址1
 * @param addressLine2 地址2
 * @param city 城市
 * @param state 州
 * @param country 国家
 * @returns 组合后的完整地址
 */
export const buildAddress = (
  addressLine1?: string,
  addressLine2?: string,
  city?: string,
  state?: string,
  zipCode?: string,
  country?: string
): string => {
  const parts = [
    addressLine1,
    addressLine2,
    city,
    state,
    zipCode,
    country
  ].filter(part => part && part.trim() !== '');
  
  return parts.join(', ');
};

/**
 * 从预约单对象中组合地址
 * @param appointment 预约单对象
 * @returns 组合后的完整地址
 */
export const buildAddressFromAppointment = (appointment: {
  addressLine1?: string;
  addressLine2?: string;
  city?: string;
  state?: string;
  zipcode?: string;
  country?: string;
}): string => {
  return buildAddress(
    appointment.addressLine1,
    appointment.addressLine2,
    appointment.city,
    appointment.state,
    appointment.zipcode,
    appointment.country
  );
};

/**
 * 从预约单对象中组合地址
 * @param appointment 预约单对象
 * @returns 组合后的完整地址
 */
export const buildAddress1AndAddress2 = (appointment: {
  addressLine1?: string | null;
  addressLine2?: string | null;
}): string => {
  return buildAddress(
      appointment.addressLine1 ?? undefined,
      appointment.addressLine2 ?? undefined
  );
};